<main class="flex column">
  <div class="flex country-selector-container">
    <payee-form-field>
      <span payee-label>Ügyfél országa</span>
      <payee-autocomplete
        [options]="countryOptions"
        [displayWith]="countryDisplayWith"
        [formControl]="clientCountryControl"
      ></payee-autocomplete>
    </payee-form-field>

    <payee-form-field>
      <span payee-label>Adós országa</span>
      <payee-autocomplete
        [options]="countryOptions"
        [displayWith]="countryDisplayWith"
        [formControl]="debtorCountryControl"
      ></payee-autocomplete>
    </payee-form-field>

    <button
      type="button"
      payee-button
      width="short"
      [disabled]="loading()"
      (click)="applyFilters()"
    >
      Szűrés
    </button>
  </div>

  <button
    payee-button
    (click)="editProduct()"
  >
    Szolgáltatás hozzáadása
  </button>

  @if (!loading()) {
    <table
      mat-table
      matSort
      class="mat-elevation-z1"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="name">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Szolgáltatás neve
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Szolgáltatás típusa
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <!-- todo human readable type -->
          {{ element.type }}
        </td>
      </ng-container>
      <ng-container matColumnDef="debtor_country_iso">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Adós országa
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ getCountryIsosDisplay(element.debtor_country_isos) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="client_country_iso">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Hitelező országa
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ getCountryIsosDisplay(element.client_country_isos) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="law_firms">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Ügyvédi irodák
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <ul>
            @for (defaultLawFirm of element.defaultLawFirms; track defaultLawFirm.id) {
              <li>
                {{ defaultLawFirm.name }}
              </li>
            }
          </ul>
        </td>
      </ng-container>
      <ng-container matColumnDef="activation">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header="is_active"
        >
          Aktív
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <payee-toggle
            [selected]="element.is_active"
            (selectionChanged)="setProductIsActive($event, element)"
          ></payee-toggle>
        </td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            payee-button
            height="short"
            width="short"
            (click)="editProduct(element)"
          >
            Szerkesztés
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            payee-icon-button
            color="white"
            [isBorderButton]="true"
            (click)="deleteProduct(element)"
          >
            <payee-icon name="trash-red"></payee-icon>
          </button>
        </td>
      </ng-container>
      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
        class="main-header"
      ></tr>
      <tr
        *matRowDef="let element; columns: displayedColumns"
        mat-row
      ></tr>
    </table>
  } @else {
    <mat-progress-spinner
      class="loading-spinner"
      color="accent"
      diameter="100"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
</main>
